import axios from 'axios';

const isDev = process.env.NODE_ENV === 'development';
const API_BASE_URL = process.env.REACT_APP_API_URL || (isDev ? 'http://localhost:5001/api' : 'https://backend-production-9dc3.up.railway.app/api');

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors and add network fallback to port 5002 (network-only)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
      return Promise.reject(error);
    }

    const isNetworkRefused = error?.code === 'ERR_NETWORK' || error?.message?.includes('Network Error') || error?.message?.includes('ECONNREFUSED');
    const usingLocalDefault5001 = isDev && (API_BASE_URL || '').includes('5001');

    // Only fall back for network connectivity errors; do not retry on 404
    if (isNetworkRefused && usingLocalDefault5001) {
      // Try remote Railway backend first
      const remoteBase = 'https://backend-production-9dc3.up.railway.app/api';
      const remote = axios.create({ baseURL: remoteBase });
      remote.interceptors.request.use((cfg) => {
        const token = localStorage.getItem('token');
        if (token) {
          cfg.headers = cfg.headers || {};
          cfg.headers.Authorization = `Bearer ${token}`;
        }
        return cfg;
      });

      const cfgRemote = { ...error.config, baseURL: remoteBase };
      try {
        const resp = await remote.request(cfgRemote);
        console.warn('API client: fell back to', remoteBase);
        return resp;
      } catch (remoteErr) {
        // Then try alternate local port 5002
        const fallbackBase = 'http://localhost:5002/api';
        const fallback = axios.create({ baseURL: fallbackBase });
        fallback.interceptors.request.use((cfg) => {
          const token = localStorage.getItem('token');
          if (token) {
            cfg.headers = cfg.headers || {};
            cfg.headers.Authorization = `Bearer ${token}`;
          }
          return cfg;
        });

        const cfg = { ...error.config, baseURL: fallbackBase };
        try {
          const resp2 = await fallback.request(cfg);
          console.warn('API client: fell back to', fallbackBase);
          return resp2;
        } catch (e2) {
          return Promise.reject(remoteErr);
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;